import { render, staticRenderFns } from "./editBlog.vue?vue&type=template&id=dac1fd48&scoped=true&"
import script from "./editBlog.vue?vue&type=script&lang=js&"
export * from "./editBlog.vue?vue&type=script&lang=js&"
import style0 from "./editBlog.vue?vue&type=style&index=0&id=dac1fd48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac1fd48",
  null
  
)

export default component.exports